import React, { useEffect, useState } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsBooking,
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const BookingStatus = ({ query = "", userPermission }) => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // Состояния для пагинации
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const loadData = async (page = 1, pageSize = 20) => {
    try {
      setIsLoading(true);
      const res = await fetchStatuses(
        "NEW",
        "BOOKING",
        query,
        setOrders,
        setIsLoading,
        setTotalCount,
        pageSize,
        page
      );
      setCurrentPage(res.data.currentPage || page);
      setLimit(pageSize);
      setTotalCount(res.data.totalCount || 0);
    } catch (err) {
      console.error("Error fetching BookingStatus:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData(1, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setLimit(pageSize);
    loadData(page, pageSize);
  };

  return (
    <div>
      <Table
        size="small"
        bordered
        loading={isLoading}
        columns={orderStatusColumnsBooking}
        dataSource={getOrderStatusDataSource(orders)}
        pagination={false} // отключаем встроенную пагинацию
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
              status="BOOKING"
            />
          ),
        }}
      />
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          onChange={handlePageChange}
          showSizeChanger
          onShowSizeChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default BookingStatus;
